<div class="d-flex pt-48-38 align-items-start">
  @if (showLogo) {
    <img src="assets/img/svg/T.svg" alt="Tracy logo" class="me-3">
  }
  <div class="d-flex align-items-center justify-content-center flex-grow-1">
    <div class="fs-44-32 fw-semibold text-center title-wrapper line-height-1" [class.max-width-350]="setMaxWidth350"
       [class.title-wrapper--remove-transform]="!showLogo">
      {{ title }}
    </div>
  </div>
</div>
